function updateList(state, discussions) {
  return Object.assign({}, state, {
    items: discussions,
  });
}

export default function(state = {}, action) {
  switch (action.type) {
    case 'DISCUSSIONS__UPDATE_LIST':
      return updateList(state, action.discussions);

  }
  return state;
}


// WEBPACK FOOTER //
// ./src/store/reducers/discussions.js